import Vue from "vue";

export default {
  namespaced: true,
  state: {
    files: [],
    contract_files: [],
    exam_files: [],
  },
  getters: {
    files: (state) => state.files,
    applicationFiles(state) {
      return state.files.filter(file => {
        return file.type === 5
      })
    },
    contractFiles: (state) => state.contract_files,
    examFiles: (state) => state.exam_files,
  },
  mutations: {
    SET_FILES(state, payload) {
      state.files = payload
    },
    RESET_FILES(state) {
      state.files = []
    },
    SET_CONTRACT_FILES(state, payload) {
      state.contract_files = payload
    },
    RESET_CONTRACT_FILES(state) {
      state.contract_files = []
    },
    SET_EXAM_FILES(state, payload) {
      state.exam_files = payload
    },
    RESET_EXAM_FILES(state) {
      state.exam_files = []
    },
  },
  actions: {
    async loadFilesByApplication({commit}, id) {
      const params = {
        application_id: id,
      }
      await Vue.axios.get('/application/files/', {params})
        .then((response) => {
          commit('SET_FILES', response.data)
        })
    },
    async loadContractFilesByApplication({commit}, id) {
      const params = {
        application_id: id,
      }
      await Vue.axios.get('/application/contract_files/', {params})
        .then((response) => {
          commit('SET_CONTRACT_FILES', response.data)
        })
    },
    async loadExamFilesByApplication({commit}, id) {
      const params = {
        application_id: id,
      }
      await Vue.axios.get('/application/exam_files/', {params})
        .then((response) => {
          console.log(response.data)
          commit('SET_EXAM_FILES', response.data)
        })
    },
  }
}
